<template>
  <div>
    <div class="s-img">
      <img src="../assets/images/service/15-1_02.jpg" />
    </div>
    <div class="s-img">
      <img src="../assets/images/service/15-1_03.jpg" />
    </div>
    <div class="s-img">
      <img src="../assets/images/service/15-1_04.jpg" />
      <div class="s-btn-to" @click="gotoUrl"></div>
    </div>
    <div class="s-img">
      <img src="../assets/images/service/15-1_05.jpg" />
    </div>
    <div class="s-img" id="anchor-0">
      <img src="../assets/images/service/15-1_06.jpg" />
    </div>
    <contactModule :titleName="titleName" :typeInt="1" id="anchor-1" />
    <div class="s-img">
      <a href="http://oms.issks.com/skoms/#/login" target="_blank">
        <img class="aImg" src="../assets/images/service/15-1_08.jpg" />
      </a>
    </div>
  </div>
</template>

<script>
import contactModule from "@/components/contactModule.vue";
export default {
  components: {
    contactModule,
  },
  data() {
    return {
      titleName: "安装申请",
    };
  },
  mounted() {
    // 延迟执行，确保路由守卫的 scrollTo(0,0) 已执行完毕
    setTimeout(() => {
      const anchorIndex = this.$route.query.anchor;
      if(anchorIndex) this.scrollToAnchor(parseInt(anchorIndex));
    }, 100);
  },
  methods: {
    gotoUrl() {
      var url = "/declares";
      this.$router.push(url);
    },
    scrollToAnchor(index) {
      const element = document.getElementById(`anchor-${index}`);
      if (element) {
        // 使用 window.scrollTo 替代 scrollIntoView，避免被路由守卫覆盖
        const offsetTop = element.offsetTop;
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style>
.s-img a .aImg {
  width: 70%;
  margin: 1rem auto;
  cursor: pointer;
}
/* ==========手机端样式====== */
@media screen and (max-width: 750px) {
  .s-img a .aImg {
    width: 100%;
  }
}
.s-btn-to {
  width: 50%;
  height: 8rem;
  cursor: pointer;
  position: absolute;
  bottom: 6%;
  left: 25%;
}
</style>
